import React from "react";
import clsx from "clsx";
import { Text } from "@merge-api/merge-javascript-shared";
import { Folder, Globe, HardDrive } from "lucide-react";
import {
  FileStorageSyncSelectionTypes,
  LinkedAccountFileStorageFilter,
} from "../../../../../../../../models/Entities";
import { NAME_COLUMN_CLASS, SIZE_COLUMN_CLASS } from "../constants";
import UpdatedCell from "./UpdatedCell";
import EmptyCellValue from "./EmptyCellValue";

interface Props {
  selection: LinkedAccountFileStorageFilter;
}

const SIZE_UNITS = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

const formatBytes = (bytes: number) => {
  if (!+bytes) return "0 Bytes";

  const k = 1000;
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(0))} ${SIZE_UNITS[i]}`;
};

const getIcon = (type: string) => {
  if (type === FileStorageSyncSelectionTypes.DRIVE) return HardDrive;
  if (type === FileStorageSyncSelectionTypes.SITE) return Globe;
  return Folder;
};

const FileStorageSyncSelectionRow = ({ selection }: Props) => {
  // derived state
  const Icon = getIcon(selection.type.toUpperCase());

  // render
  return (
    <>
      {/* Name cell contains customer-tenant content and is thus masked at the cell */}
      <div role="cell" title={selection.name} className={clsx(NAME_COLUMN_CLASS, "ph-no-capture")}>
        <Icon size={16} className="shrink-0 text-gray-40" />
        <Text className="min-w-0 truncate">{selection.name}</Text>
      </div>
      <div role="cell" className={SIZE_COLUMN_CLASS}>
        {selection.size ? <Text>{formatBytes(Number(selection.size))}</Text> : <EmptyCellValue />}
      </div>
      <UpdatedCell updatedAt={selection.updated_at} />
    </>
  );
};

export default FileStorageSyncSelectionRow;
